const sentryIdentifyingKeys = ["forwarded", "-ip", "remote-", "via", "-user"]

// Sentry 11 collects user info, cookies, bodies and query data unless told otherwise. This restores the v10 defaults
// of `sendDefaultPii: false` from the official migration guide.
export const sentryDataCollection = {
	userInfo: false,
	cookies: false,
	httpHeaders: {
		request: { deny: sentryIdentifyingKeys },
		response: { deny: sentryIdentifyingKeys },
	},
	httpBodies: [],
	urlQueryParams: { deny: sentryIdentifyingKeys },
	genAI: { inputs: false, outputs: false },
	databaseQueryData: false,
	queues: false,
	graphQL: { document: false, variables: false },
}
